import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleCreatorUserPickup } from "@fixa/notifications";
import { getTitleAssignerString } from "../utils/task-notification-title";
import styles from "../task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorUserPickupProps extends ComponentNotificationTitleCreatorUserPickup {
  read: boolean;
}
const TaskNotificationTitleCreatorUserPickup = ({
  props: { assignedBy },
  read,
}: TaskNotificationTitleCreatorUserPickupProps) => {
  const { t } = useTranslation();
  const assignedByString = getTitleAssignerString(assignedBy);
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("hasPickupTaskCreatedByYouString", {
        assignedBy: assignedByString,
      })}
    </div>
  );
};

export default TaskNotificationTitleCreatorUserPickup;
